import { defineMessages } from 'react-intl';

export const messages: {
	heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	favoriteSection: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recommendedSection: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	browseAgents: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createAgent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noAgentsFound: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loadingError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	heading: {
		id: 'object-sidebar-components.confluence-agent-menu.heading',
		defaultMessage: 'Select an agent',
		description: 'Heading for the Confluence agent picker dropdown in the object sidebar',
	},
	searchPlaceholder: {
		id: 'object-sidebar-components.confluence-agent-menu.search-placeholder',
		defaultMessage: 'Search agents',
		description: 'Placeholder text for the agent search input in the Confluence agent picker',
	},
	favoriteSection: {
		id: 'object-sidebar-components.confluence-agent-menu.favorite-section',
		defaultMessage: 'Favorite',
		description: 'Section heading for favorited agents in the Confluence agent picker',
	},
	recommendedSection: {
		id: 'object-sidebar-components.confluence-agent-menu.recommended-section',
		defaultMessage: 'Recommended',
		description: 'Section heading for recommended agents in the Confluence agent picker',
	},
	browseAgents: {
		id: 'object-sidebar-components.confluence-agent-menu.browse-agents',
		defaultMessage: 'Browse agents',
		description: 'Label for the browse agents button in the Confluence agent picker',
	},
	createAgent: {
		id: 'object-sidebar-components.confluence-agent-menu.create-agent',
		defaultMessage: 'Create agent',
		description: 'Label for the create agent button in the Confluence agent picker',
	},
	noAgentsFound: {
		id: 'object-sidebar-components.confluence-agent-menu.no-agents-found',
		defaultMessage: 'No agents found',
		description:
			'Message shown when no agents match the search query in the Confluence agent picker',
	},
	loading: {
		id: 'object-sidebar-components.confluence-agent-menu.loading',
		defaultMessage: 'Loading agents',
		description: 'Accessible label for the loading spinner in the Confluence agent picker',
	},
	loadingError: {
		id: 'object-sidebar-components.confluence-agent-menu.loading-error',
		defaultMessage: 'Failed to load agents. Please try again.',
		description: 'Error message shown when agents fail to load in the Confluence agent picker',
	},
});
